﻿import * as React from "react";
import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";
import { File } from ".";

export interface IFileElementProps {
    bindFile: (file: File) => void;
    content: File;
    refresh: () => void;
    smartBoardsUrl: string;
}

export const FileElement: React.FunctionComponent<IFileElementProps> = (
    props,
): React.ReactElement => {
    const onClickHander = (): void => {
        props.bindFile(props.content);
    };

    const onDeleteClick = (): void => {
        void deleteSmartBoard();
    };

    const deleteSmartBoard = async (): Promise<void> => {
        await $.ajax({
            method: `DELETE`,
            url: `${props.smartBoardsUrl}/api/Storage?dashboardid=${props.content.id}`,
        });

        props.refresh();
    };

    return (
        <React.Fragment>
            <ContextMenuTrigger id={`file-${props.content.id}`}>
                <div
                    className={`treeitem treeitem-file`}
                    onClick={onClickHander}
                >
                    <div className={`file-icon`}>
                        <img src={`/Images/FileIcon.svg`} />
                    </div>
                    {props.content.name}
                </div>
            </ContextMenuTrigger>
            <ContextMenu id={`file-${props.content.id}`}>
                <MenuItem>
                    <div className={`contextmenu-menuitem`}>
                        <div className={`menuitem-itemicon`}>
                            <img src={`/Images/FavouriteIcon.svg`} />
                        </div>
                        <div className={`menuitem-itemtext`}>Favourite</div>
                    </div>
                </MenuItem>
                <MenuItem>
                    <div className={`contextmenu-menuitem`}>
                        <div className={`menuitem-itemicon`}>
                            <img src={`/Images/RenameIcon.svg`} />
                        </div>
                        <div className={`menuitem-itemtext`}>Rename</div>
                    </div>
                </MenuItem>
                <MenuItem>
                    <div className={`contextmenu-menuitem`}>
                        <div className={`menuitem-itemicon`}>
                            <img src={`/Images/MoveFolderIcon.svg`} />
                        </div>
                        <div className={`menuitem-itemtext`}>Move To...</div>
                    </div>
                </MenuItem>
                <MenuItem onClick={onDeleteClick}>
                    <div className={`contextmenu-menuitem`}>
                        <div className={`menuitem-itemicon`}>
                            <img src={`/Images/DeleteIcon.svg`} />
                        </div>
                        <div className={`menuitem-itemtext`}>Delete</div>
                    </div>
                </MenuItem>
            </ContextMenu>
        </React.Fragment>
    );
};
